module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-allorderbill"
  }, [_c('navbar', {
    attrs: {
      "title": "单据统计-流水"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll",
    attrs: {
      "id": "common-scroll"
    },
    on: {
      "scroll": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "ui-search-input ui-search-input-l",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "ui-listview"
  }, _vm._l((_vm.billCountSerials), function(billCountSerial) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/bill-count-serial-detail',
          query: {
            bill_id: billCountSerial.id
          }
        }
      }
    }, [_c('p', {
      staticClass: "allorderbill-list-p"
    }, [_vm._v(_vm._s(billCountSerial.restaurant_name) + "\n\t\t\t\t\t\t\t"), (billCountSerial.bill_state == 10) ? _c('span', {
      staticClass: "grey-font"
    }, [(billCountSerial.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("未处理\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (billCountSerial.bill_state == 11) ? _c('span', {
      staticClass: "aqua-font"
    }, [(billCountSerial.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("待发货\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (billCountSerial.bill_state == 12) ? _c('span', {
      staticClass: "orange-font"
    }, [(billCountSerial.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("已发货\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (billCountSerial.bill_state == 13) ? _c('span', {
      staticClass: "ink-font"
    }, [(billCountSerial.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("已收货 未确认\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (billCountSerial.bill_state == 14) ? _c('span', {
      staticClass: "ink-font",
      staticStyle: {
        "color": "#70B603"
      }
    }, [(billCountSerial.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("已收货 已确认\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (billCountSerial.bill_state == 20) ? _c('span', {
      staticClass: "grey-font"
    }, [(billCountSerial.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("未确认\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (billCountSerial.bill_state == 21) ? _c('span', {
      staticClass: "red-font"
    }, [(billCountSerial.urgent_flag == 1) ? _c('i', {
      staticClass: "tips-flag"
    }, [_vm._v("加急")]) : _vm._e(), _vm._v("已确认\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "ui-detail-listview"
    }, [_c('li', [_vm._v("单号：" + _vm._s(billCountSerial.trans_bill_no))]), _vm._v(" "), _c('li', [_vm._v("订货日期：" + _vm._s(_vm.dateCut(billCountSerial.from_date)))]), _vm._v(" "), _c('li', [_vm._v("送往：" + _vm._s(billCountSerial.to_organ_name))]), _vm._v(" "), _c('li', [_vm._v("收货日期：" + _vm._s(_vm.dateCut(billCountSerial.to_date)))]), _vm._v(" "), _c('li', [_vm._v("订货金额：" + _vm._s(_vm._f("numFixed")(billCountSerial.sum_money, _vm.numScale)) + "元")]), _vm._v(" "), _c('li', [_vm._v("发货金额：" + _vm._s(_vm._f("numFixed")(billCountSerial.sum_money_send, _vm.numScale)) + "元")]), _vm._v(" "), _c('li', [_vm._v("实收金额：" + _vm._s(_vm._f("numFixed")(billCountSerial.sum_money_recipient, _vm.numScale)) + "元")])]), _vm._v(" "), _c('p', {
      staticClass: "allorderbill-total-p"
    }, [_vm._v("共"), _c('strong', [_vm._v(_vm._s(billCountSerial.detail_num))]), _vm._v("种品项")])])], 1)
  }), 0)]), _vm._v(" "), _c('refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shown),
      expression: "!shown"
    }],
    attrs: {
      "cls": _vm.cls,
      "font": _vm.font
    }
  }), _vm._v(" "), _c('mid-ware', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.midware),
      expression: "midware"
    }],
    attrs: {
      "icon": _vm.icon,
      "midFont": _vm.midFont
    }
  })], 1), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a426a52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BillCountSerial.vue
// module id = 585
// module chunks = 1